<main id="issue-receipt" class="info">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{ _('receipt_issuance') }}</h1>
            <span
                class="icon back"
                @click="app.code ? app.setPage('Terminal') : back()"
            >
                chevron_left
            </span>
        </div>
    </header>
    <section
        v-if="canDownloadReceipt && app.invoice_amount && receipt_urls.length < 2"
    >
        <div>
            <h2><span>➊</span>{{_('please_check_reservation')}}</h2>
            <h3>{{_('reserve_title')}}</h3>
            <table class="info black-border">
                <tr>
                    <th>{{_('accommodation_period')}}</th>
                    <td>{{accommodationPeriod()}}</td>
                </tr>
                <tr>
                    <th>{{_('number_of_rooms')}}</th>
                    <td>{{app.reserve.room_count}}{{_('per_room')}}</td>
                </tr>
                <tr>
                    <th>{{_('number_of_persons')}}</th>
                    <td>{{app.reserve.guest_count}}{{_('per_person')}}</td>
                </tr>
                <tr v-if="app.invoice_amount">
                    <th>{{_('invoice_amount')}}</th>
                    <td>
                        {{app.invoice_amount | price}} ({{_('include_tax')}})
                    </td>
                </tr>
            </table>
        </div>
        <div
            v-if="!receipt_urls.length && (app.checkedout || app.reserve?.canceled)"
        >
            <h2><span>➋</span>{{_('please_select_destination')}}</h2>
            <ul>
                <li>
                    <label>
                        <input
                            type="radio"
                            value="select"
                            v-model="addressee_input_method"
                        />
                        <span>{{ _('addressee_selection') }}</span>
                    </label>
                    <div class="select-wrapper">
                        <select
                            v-model="addressee_selection"
                            :disabled="addressee_input_method === 'text'"
                        >
                            <option value="guest_name">
                                {{app.addressee_options['guest_name']}}
                            </option>
                            <option
                                value="company_name"
                                v-if="app.addressee_options['company_name']"
                            >
                                {{app.addressee_options['company_name']}}
                            </option>
                        </select>
                    </div>
                </li>
                <li>
                    <label>
                        <input
                            type="radio"
                            value="text"
                            v-model="addressee_input_method"
                        />
                        <span>{{ _('enter_address') }}</span>
                    </label>
                    <div class="input-text-wrapper">
                        <input
                            type="text"
                            v-model="addressee_text"
                            :disabled="addressee_input_method === 'select'"
                        />
                    </div>
                </li>
            </ul>
        </div>
    </section>
    <section v-else-if="canDownloadReceipt && receipt_urls.length > 1">
        <h2>{{_('download_receipt_description', receipt_urls.length)}}</h2>
        <template v-if="status === 'idle'">
            <button
                v-for="(url, i) in receipt_urls"
                class="issue-btn"
                @click="downloadReceipt(i)"
                v-if="status === 'idle'"
            >
                <span class="symbol fill">receipt_long</span
                >{{_('download_receipt', i+1)}}
            </button>
        </template>
    </section>
    <section v-else>
        <h2>{{_('cannot_download_receipt')}}</h2>
    </section>
    <template
        v-if="canDownloadReceipt && app.invoice_amount && (app.checkedout || app.reserve?.canceled) && receipt_urls.length < 2"
    >
        <button class="issue-btn" @click="issue" v-if="status === 'idle'">
            <span class="symbol fill">receipt_long</span
            >{{_('receipt_issuance')}}
        </button>
        <p class="loading" v-else>Loading...</p>
    </template>
    <p
        class="loading"
        v-if="canDownloadReceipt && app.invoice_amount && !app.checkedout && !app.reserve?.canceled"
    >
        {{_('can_issue_after_checkout')}}
    </p>
    <div class="remarks">{{_('receipt_issuance_description')}}</div>
    <tab-bar v-if="!isCancellationFee" :page="app.query.page"></tab-bar>
</main>
